/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';

import * as actions from '../action';
import * as c from '../constant';
import TransactionContent from './TransactionsContent';

const form = {
  is_valid: 'ALL',
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
};

const statusOptions = [
  { label: 'ALL', value: 'ALL' },
  { label: 'WAITING FOR APPROVAL', value: 0 },
  { label: 'APPROVED', value: 1 },
];

function TransactionContainer({
  getViolationsList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  // approveTransaction,
  showTransactionTrafficViolator,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getViolationsList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    is_valid: filter.is_valid
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  // const handleOnChangeSelect = key => e => {
  //   setFilter({
  //     ...filter,
  //     [key]: e.value,
  //     // transaction_status: e.value,
  //     // transaction_type: 'BIRTH CERTIFICATE',
  //   });
  //   getViolationsList({
  //     ...filter,
  //     // transaction_status: e.value,
  //     // transaction_type: 'BIRTH CERTIFICATE',
  //   });
  // };

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      let args = {};

      if (filter.is_valid === 'ALL' || formData.is_valid) {
        args = _.omit(args, ["is_valid"]);
      } else {
        args = {
          is_valid: filter.is_valid || formData.is_valid
        }
      }
      
      getViolationsList({
        ...args,
        q: formData.keyword,
      });
    } else {
       let args = {};

      if (filter.is_valid === 'ALL' || formData.is_valid) {
        args = _.omit(args, ["is_valid"]);
      } else {
        args = {
          is_valid: filter.is_valid || formData.is_valid
        }
      }

      getViolationsList(args);
    }
  }, [debouncedSearchTerm]);

  // const handleApprove = (data) => (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to Approve this application?x',
  //     (remarks) => {
  //       approveTransaction(
  //         _.get(data, 'id'),
  //         {
  //           remarks,
  //           status: 'WAITING FOR PAYMENT',
  //         },
  //         () => {
  // showTransactionTrafficViolator(_.get(data, 'id'));
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  // const handleReject = (data) => (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to Reject this application',
  //     (remarks) => {
  //       approveTransaction(
  //         _.get(data, 'id'),
  //         {
  //           remarks,
  //           status: 'FOR APPEARANCE',
  //         },
  //         () => {
  // showTransactionTrafficViolator(_.get(data, 'id'));
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  const onSetStatusFilter = () => e => {
    setFilter({
      ...filter,
      is_valid: e.value,
    });

    let args = {};

    if (e.value === 'ALL') {
      args = _.omit(args, ["is_valid"]);
    } else {
      args = {
        ...param,
        is_valid: e.value
      }
    }

    getViolationsList(
      args,
      (response) => {
        if (_.get(response, 'data').length > 0) {
          const id = _.get(response, 'data.0.id');
          history.push(
            `/ordinance-violation-receipts/violations/list/${id}`
          );
          showTransactionTrafficViolator(id);
        }
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            getData={getViolationsList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search OVR..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="OVR List"
            renderItem={item => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.first_name')}{' '}
                  {_.get(item, 'attributes.middle_name')}{' '}
                  {_.get(item, 'attributes.last_name')}{' '}
                  {_.get(item, 'attributes.extension_name') || ''}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'attributes.ovr_number')
                    ? _.get(item, 'attributes.ovr_number')
                    : '---'}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            setStatusFilter={onSetStatusFilter('is_valid')}
            statusFilter
            statusOptions={statusOptions}
            status={_.get(filter, 'is_valid') || ''}
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <TransactionContent
                        UpdateData={UpdateData}
                      // onApprove={handleApprove}
                      // onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

TransactionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getViolationsList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransactionTrafficViolator: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionContainer);
